import { useCallback, useEffect, useState } from 'react'
import IssuesService from '../../../services/api/IssuesService'

const noop = () => {
  // No cleanup needed when fetch is disabled.
}

const useIssueDetail = (collectId, issueId, { enabled = true, initialIssue = null } = {}) => {
  const [issue, setIssue] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [refetchToken, setRefetchToken] = useState(0)

  const refetch = useCallback(() => setRefetchToken(token => token + 1), [])

  useEffect(() => {
    if (!enabled || !issueId) {
      setIssue(null)
      setLoading(false)
      setError(null)
      return noop
    }
    if (initialIssue?.id === issueId && refetchToken === 0) {
      setIssue(initialIssue)
      setLoading(false)
      setError(null)
      return noop
    }
    let cancelled = false
    setIssue(null)
    setLoading(true)
    setError(null)

    IssuesService.getIssue(collectId, issueId)
      .then(response => {
        if (cancelled)
          return
        setIssue(response)
      })
      .catch(err => {
        if (cancelled)
          return
        setError(err)
        setIssue(null)
      })
      .finally(() => {
        if (!cancelled)
          setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [collectId, issueId, enabled, refetchToken, initialIssue])

  return { issue, loading, error, refetch }
}

export default useIssueDetail
